import { useMemo } from "react";
import useUser from "../../modules/user/hooks/use-user";

type Props = {
    id: string,
    requires?: string
}

const Path: React.FC<Props> = ({ id, requires }) => {
    const { user } = useUser();
    const completedTask = useMemo(() => user?.completedTasks || [], [user]);

    return <>
        {requires && completedTask.includes(requires) && <div className={`path-segment ${id}`}></div> }
        {!requires && <div className={`path-segment ${id}`}></div>}
    </>
}

export default Path;
